export const icons = {
  IST: 'tokens/IST.png',
  BLD: 'tokens/BLD.svg',
  ATOM: 'tokens/cosmos.svg',
  LINK: 'tokens/chainlink.png',
  USDC: 'tokens/usdc.svg',
  USDC_grv: 'tokens/USDC_grv.webp',
  USDC_axl: 'tokens/USDC_axl.png',
  USDT_grv: 'tokens/USDT_grv.webp',
  USDT_axl: 'tokens/USDT_axl.png',
  DAI_axl: 'tokens/DAI_axl.png',
  stATOM: 'tokens/statom.svg',
  DAI_grv: 'tokens/DAI_grv.png',
  USDT: 'tokens/USDT.png',
  stTIA: 'tokens/sttia.svg',
  stOSMO: 'tokens/stosmo.svg',
  stkATOM: 'tokens/stkatom.svg',
};

export const defaultIcon = 'tokens/default.png';
